/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.reviews')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortReviewsPageServerSideProps } from 'page-components/resort/reviews';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchResortSlugs } from 'util/fetchResortSlugs';
import { isMainLocale } from 'util/i18nFlags';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortReviewsPageServerSideProps);
/* export const getStaticPaths = async () => packPaths(
  isMainLocale() ? (await fetchResortSlugs('resort.reviews')).map((res) => ({
    region: res.region,
    resort: res.slug,
  })) : [],
); */
